import React from "react";

// Libellé lisible d'un compte connecté — utilise l'ID de compte publicitaire
// choisi s'il existe, sinon la date de connexion (les comptes fraîchement
// connectés n'ont pas encore de compte pub sélectionné).
const accountLabel = (acc) => {
  const id = acc.meta_ads_account_id || acc.tiktok_ads_advertiser_id || acc.snapchat_ads_advertiser_id || acc.google_ads_id;
  if (id) return `Compte ${id}`;
  const d = acc.created_at ? new Date(acc.created_at) : null;
  return d ? `Connecté le ${d.toLocaleDateString()}` : `Connexion #${acc.id}`;
};

const ConnectedPlatformCard = ({
  platform,
  loading,
  index,
  handlePlatformConnect,
  handlePlatformDisconnect,
  handleConfigurePlatformClick,
  handleActivateAccount,
  handleDisconnectAccount,
}) => {
  const accounts = platform.accounts || [];
  const isConnected = accounts.length > 0;

  return (
    <div
      key={index}
      className="p-5 bg-gray-50 rounded-2xl shadow-sm hover:shadow-none border border-transparent hover:border-primary-500 transition-all flex flex-col gap-2"
    >
      <div className="grow flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <p className="text-xs font-bold uppercase text-rose-400 tracking-widest">
            {platform.tagline || "PREMIUM"}
          </p>
          <div className="flex items-center gap-3">
            <div className="flex-none h-fit w-fit p-2.5 bg-white rounded shadow-xs">
              <div
                className="rounded object-contain overflow-hidden flex items-center justify-center"
                style={{ width: "20px", height: "20px" }}
              >
                <img
                  width="20"
                  height="20"
                  src={platform.icon}
                  alt={platform.name}
                  className="flex-grow-0"
                  style={{ width: "20px", height: "20px" }}
                />
              </div>
            </div>
            <p className="text-md font-semibold">{platform.name}</p>
            <div className="ml-auto flex items-center gap-2">
              {isConnected && (
                <button
                  type="button"
                  className="px-3 py-2 rounded-lg text-sm text-gray-500 hover:text-[#221C51]"
                  onClick={() => handleConfigurePlatformClick(platform.slug)}
                >
                  Configure
                </button>
              )}
              <button
                type="button"
                disabled={loading}
                className={`px-6 py-2 rounded-lg shadow-md ${
                  isConnected
                    ? "border border-[#221C51] text-[#221C51] bg-white"
                    : "border bg-[#221C51] text-white"
                }`}
                onClick={() => handlePlatformConnect(platform.slug)}
              >
                {isConnected && platform.multiAccount ? "+ Connecter un autre compte" : isConnected ? "Reconnecter" : "Connect"}
              </button>
            </div>
          </div>
        </div>
        <p className="text-sm font text-gray-500">{platform.description}</p>

        {isConnected && (
          <div className="flex flex-col gap-1.5">
            {accounts.map((acc) => (
              <div key={acc.id} className="flex items-center justify-between gap-2 px-3 py-2 bg-white rounded-lg border border-gray-200">
                <div className="flex items-center gap-2 min-w-0">
                  {acc.is_active ? (
                    <span className="flex-none text-[10px] font-bold uppercase text-white bg-emerald-500 rounded-full px-2 py-0.5">Actif</span>
                  ) : platform.multiAccount ? (
                    <button
                      type="button"
                      className="flex-none text-[10px] font-bold uppercase text-gray-500 border border-gray-300 rounded-full px-2 py-0.5 hover:border-[#221C51] hover:text-[#221C51]"
                      onClick={() => handleActivateAccount(acc.id)}
                    >
                      Utiliser
                    </button>
                  ) : null}
                  <span className="text-sm text-gray-700 truncate">{accountLabel(acc)}</span>
                </div>
                <button
                  type="button"
                  className="flex-none text-xs text-gray-400 hover:text-red-600"
                  onClick={() => (platform.multiAccount ? handleDisconnectAccount(platform.slug, acc.id) : handlePlatformDisconnect(platform.slug))}
                >
                  Déconnecter
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ConnectedPlatformCard;
